import React, { useState, useEffect } from "react";
import { Card, Form, Button, Alert, Row, Col } from "react-bootstrap";
import { useColors } from "../../../contexts/ColorContext";
import api from "../../../services/api";
import { getContrastingTextColor } from "../../../utils/colorUtils";

function ConfiguracaoCores({ idClienteMaster }) {
  const { colors, updateColors } = useColors();
  const [formData, setFormData] = useState(colors);
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState(null);

  // Carrega as cores do backend quando o componente monta
  useEffect(() => {
    const fetchColors = async () => {
      try {
        const response = await api.get(`/ConfiguracaoCores/${idClienteMaster}`);

        if (response.data) {
          setFormData(response.data);
          updateColors(response.data);
        }
      } catch (error) {
        console.error("Erro ao carregar cores:", error);
        setMessage({
          type: "danger",
          text: "Erro ao carregar as configurações de cores.",
        });
      }
    };

    if (idClienteMaster) fetchColors();
  }, [idClienteMaster]); // evitar re-render infinito por updateColors

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setMessage(null);

    try {
      await api.put(`/ConfiguracaoCores/${idClienteMaster}`, formData);
      updateColors(formData);

      setMessage({
        type: "success",
        text: "Configurações de cores salvas com sucesso!",
      });
    } catch (error) {
      console.error("Erro ao salvar cores:", error);
      setMessage({
        type: "danger",
        text: "Erro ao salvar as configurações de cores.",
      });
    } finally {
      setLoading(false);
    }
  };

  const handleReset = () => {
    setFormData(colors);
    setMessage(null);
  };

  // Renderização de cada campo de cor
  const renderColorInput = (label, name, description) => (
    <Form.Group as={Col} md="6" className="mb-3">
      <Form.Label>{label}</Form.Label>
      <div className="d-flex align-items-center">
        <Form.Control
          type="color"
          name={name}
          value={formData[name] || "#ffffff"}
          onChange={handleChange}
          style={{ width: "50px", height: "50px", marginRight: "10px" }}
        />
        <Form.Control
          type="text"
          name={name}
          value={formData[name] || "#ffffff"}
          onChange={handleChange}
          maxLength={7}
          style={{ width: "100px" }}
        />
        <div
          className="ms-3 p-2 rounded"
          style={{
            backgroundColor: formData[name] || "#ffffff",
            color: getContrastingTextColor(formData[name] || "#ffffff"),
            border: "1px solid #ccc",
          }}
        >
          {description}
        </div>
      </div>
    </Form.Group>
  );

  return (
    <Card className="shadow-lg" style={cardStyle}>
      <Card.Header>Configuração de Cores da Marca</Card.Header>
      <Card.Body>
        {message && <Alert variant={message.type}>{message.text}</Alert>}

        <Form onSubmit={handleSubmit}>
          <Row>
            {renderColorInput(
              "Cor Primária",
              "primaryColor",
              "Cor principal da marca."
            )}
            {renderColorInput(
              "Cor Secundária",
              "secondaryColor",
              "Cor de elementos auxiliares."
            )}
          </Row>

          <Row>
            {renderColorInput(
              "Cor de Texto Principal",
              "textColor",
              "Usado na maior parte dos textos."
            )}
            {renderColorInput(
              "Cor de Texto Claro",
              "textColorLight",
              "Usado em fundos escuros."
            )}
          </Row>

          <Row>
            {renderColorInput(
              "Cor de Fundo da Página",
              "backgroundColor",
              "Cor de fundo de todo o sistema."
            )}
          </Row>

          <Row>
            {renderColorInput(
              "Cor de Fundo do Card",
              "cardBackgroundColor",
              "Fundo de cards e painéis."
            )}
            {renderColorInput(
              "Cor do Texto do Card",
              "cardTextColor",
              "Texto dentro dos cards."
            )}
          </Row>

          <Row>
            {renderColorInput(
              "Cor do Botão",
              "buttonColor",
              "Cor dos botões principais."
            )}
            {renderColorInput(
              "Cor do Texto do Botão",
              "buttonTextColor",
              "Texto dos botões."
            )}
          </Row>

          <div className="d-flex justify-content-end mt-4">
            <Button variant="secondary" onClick={handleReset} className="me-2">
              Redefinir
            </Button>

            <Button variant="primary" type="submit" disabled={loading}>
              {loading ? "Salvando..." : "Salvar Configurações"}
            </Button>
          </div>
        </Form>
      </Card.Body>
    </Card>
  );
}

export default ConfiguracaoCores;

  const cardStyle = {
    backgroundColor: "#3c4049",
    color: "#fff",
    border: "none",
    borderRadius: "10px",
    padding: "25px",
    width: "95%",
    maxWidth: "1200px",
    margin: "0 auto",
  };
